import {CreatePlanNode} from "../view-model";
import {findPathToNode} from "./findPathToNode";
import {Interceptor} from "../../../../utils";
import {operationalNodesAreImmutable} from "./operationalNodesAreImmutable";
import {complexNodeDescendentsAreImmutable} from "./complexNodeDescendentsAreImmutable";

/**
 * This high-order function prepares a simple hierarchy creation plan
 * by:
 * <ul>
 *   <li>
 *     Selecting all nodes in the path starting from the specified child
 *     node up to and including the root node.
 *   </li>
 *   <li>
 *     Each node in the selection path is marked as immutable, indicating that
 *     its node selection state cannot be changed.
 *   </li>
 *   <li>
 *     All nodes whose source client entity is already operational are marked
 *     as immutable.
 *   </li>
 *   <li>
 *     Performing other business logic checks or modifications.
 *   </li>
 * </ul>
 *
 * @param from The identifier of the node from which to start selecting parents.
 */
export const prepareSimplePlan = (
  from: string
): Interceptor<CreatePlanNode> => {
  return root => {
    // 1. The selection path is immutable
    findPathToNode(root, from).forEach(node => {
      node.selected = true;
      node.immutable = true;
    });
    // 2. Operational nodes are immutable
    operationalNodesAreImmutable(root);
    // 3. Complex node descendents are immutable
    complexNodeDescendentsAreImmutable(root);
    return root;
  };
};
